import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

import {
  ROLLOUT_AUTOJOIN_SIDEBAR,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SIDEBAR,
} from 'constants/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';

import GetSuggestedWorkspaceForSidebarBanner from './GetSuggestedWorkspaceForSidebarBanner';

export default function useSuggestedWorkspace() {
  const hasAutoJoinFlag = useFlagIsActivated({
    flag: ROLLOUT_AUTOJOIN_SIDEBAR,
    activationValues: ['show-new'],
  });

  const hasSuggestedWorkspaceFlag = useFlagIsActivated({
    flag: ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SIDEBAR,
    activationValues: [true],
  });

  const hasFlag = hasSuggestedWorkspaceFlag || hasAutoJoinFlag;

  const [runQuery, result] = useLazyQuery(
    GetSuggestedWorkspaceForSidebarBanner,
    {
      fetchPolicy: 'cache-first',
    }
  );

  useEffect(() => {
    if (hasFlag) {
      runQuery();
    }
  }, [hasFlag, runQuery]);

  return {
    hasFlag,
    result,
  };
}
